// extracted by extract-css-chunks-webpack-plugin
module.exports = {"offer-form":"offer-form___fa4Ea","row":"row___VgcVY","full":"full___i7AGP","half":"half___fLSQF"};